const DAY_SHORT = 'DD/MM/YYYY'
const TIME = 'HH:mm'
const TIME_MERIDIEM = 'LT'
const ISO = 'YYYY-MM-DD'
const DAY_SHORT_YEAR = 'DD/MM/YY'
const DAY_MONTH = 'DD/MM'

export const DATE_KEYS = {
  FORMAT: {
    ISO,
    DAY_SHORT,
    FULL_TIME: `${ISO} ${TIME}`,
    YEAR: 'YYYY',
    MONTH_YEAR: 'MMMM YYYY',
    TIME,
    TIME_MERIDIEM,
    DAY_SHORT_YEAR,
    DAY_MONTH,
    YEAR_MONTH: 'YYYY/MM/DD',
  },
}
